import React, { useRef, useState } from "react";
import Loader from "../../loader/loader";
import { getDataTransferItems } from "../../image-editing/lib/imageData";
import { isValidMultiple } from "../../form-inputs/imageUploader/lib/fileHelper";
import { useFileType } from "../../../shared/hooks/use-file-type";
import classNames from "classnames";

const UploadImage = ({ zipUpload, multiple = true, isRequired, ...props }) => {
    const [isDragActive, setIsDragActive] = useState(false);
    const fileType = useFileType(zipUpload);
    const fileInputRef = useRef();

    const openFilePicker = (event) => {
        if (event.altKey) {
            return props.handleCopy(event);
        }

        if (event.ctrlKey || event.metaKey) {
            return;
        }

        if (!props.isUploading) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
        }
    };
    const onFileChange = () => {
        const files = fileInputRef.current.files;
        const validFiles = isValidMultiple(files, fileType);

        if (validFiles.length) {
            props.uploadImages(validFiles);
        }
    };
    const onDragEnter = (e) => {
        e.preventDefault();
        setIsDragActive(true);
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDragLeave = (e) => {
        e.preventDefault();
        setIsDragActive(false);
    };

    const onDrop = (e) => {
        e.preventDefault();

        const fileList = getDataTransferItems(e);
        const validFiles = isValidMultiple(fileList, fileType);

        if (validFiles.length) {
            props.uploadImages(validFiles);

            setIsDragActive(false);
        }
    };

    const renderUploadDragDrop = () => {
        const loadingHtml = props.isUploading ? <Loader /> : null;

        return (
            <div
                className={classNames("upload-box", {
                    "-upload-active": props.isUploading,
                    "-drag-active": isDragActive,
                    "-read-only": props.isReadOnly,
                    "-required": isRequired,
                })}
                onClick={openFilePicker}
                onDragEnter={onDragEnter}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                {loadingHtml}
            </div>
        );
    };

    const imageOrUpload = !props.isQA && !props.isCompleted ? renderUploadDragDrop() : null;
    const isReadOnly = props.isReadOnly ? " -read-only" : "";

    return (
        <div>
            <div className={`upload-image${isReadOnly}`}>
                <div className="hide">
                    <input
                        type="file"
                        onChange={onFileChange}
                        accept={fileType}
                        ref={fileInputRef}
                        multiple={multiple}
                    />
                </div>
                {imageOrUpload}
            </div>
        </div>
    );
};

export default UploadImage;
